import VueClipboard from 'vue-clipboard2'

export default async ({ Vue }) => {
  Vue.use(VueClipboard)
}
